@if (stores$ | async; as stores) {
  @defer {
    <boels-vertical-aligner id="regions">
      <h3 class="boels-store-finder-region__title">
        {{ 'storeFinder.count.title' | transloco }}
      </h3>
      <ul class="boels-store-finder-region__branches">
        @for (store of stores; track store) {
          <li class="boels-store-finder-region__branches__item">
            <a
              [cmsRouterLink]="['branches', store.name]"
              [queryParams]="specialismParam$ | async"
            >
              <span>{{ store.name }}</span>
            </a>
          </li>
        }
      </ul>
    </boels-vertical-aligner>
  }
}
